import { containerPesquisaStyles } from './ContainerPesquisa.styles'

export function containerPesquisaIO() {
  return {
    styles: containerPesquisaStyles
  }
}

export type ContainerPesquisaIO = ReturnType<typeof containerPesquisaIO>
